






























import { Vue,Component } from 'vue-property-decorator'
import { State,Action,namespace } from 'vuex-class'
import PagedTable from '../../components/common/pagedTable.vue'
const customer = namespace('customer')
@Component({
    components: {
        PagedTable,
    }
})
export default class Home extends Vue{
    search:any = {
        name: '',
        phone: '',
        site: '',
        page: 1
    }
    @customer.State('customerPager') customerPager:any //表格的页码
    @customer.State('customerList') customerList:any //用户列表
    @customer.State('loading') loading:any 
    get tablecolumn(){
        return [
            {
                prop: 'name',
                type: 'text',
                label: '用户名',

            },
            {
                prop: 'phone',
                type: 'text',
                label: '手机号',

            },
            {
                prop: 'count',
                type: 'text',
                label: '购物次数',

            },
            {
                prop: 'operation',
                name: 'operation',
                type: 'slot',
                label: '操作',
                width: '270px'
            }
        ]
    }
    @customer.Action('getCustomerList') getCustomerList:any
    @customer.Action('modifyCustomer') modifyCustomer:any
    @customer.Action('deleteCustomer') deleteCustomer:any
    @customer.Action('exportCustomer') exportCustomer:any
    
    mounted(){
        this.getList()
    }
    getList(){
        this.getCustomerList(this.search)
    }
    // 网点改变的时候
    changeSite(val:string){
        this.search.site = val
        this.getList()
    }
    // 翻页
    pagechange(e:any){
        console.log(e[0].val);
        this.search.page = e[0].val
        this.getList()
    }
    // 加入黑名单
    async addBlack(id:string,status:boolean){
        const data = await this.modifyCustomer({
            id: id,
            data: {
                inblacklist: status
            }
        })
        if(data){
            this.getList();
            this.$message({
                message: '操作成功',
                type: 'success'
            });
        }
    }
    // 删除
    async deleteRow(id:string){
        this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            const res = await this.deleteCustomer(id)
            if(res){
                this.getList();
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
            }
        }).catch();
    }
    // 导出数据
    async exportexcel(){
        const data = await this.exportCustomer({
            site: this.search.site
        });
        console.log(data.data);
        if(data){
            require.ensure([], () => {
                const { export_json_to_excel } = require('../../assets/vendor/Export2Excel');
                const pk = [{
                    sheetName:"客户信息统计",
                    data:data
                }];
                const extitle = `客户信息导出`
                export_json_to_excel(pk,extitle);
            })
        }
    }
}
